import { useQuery } from "@tanstack/react-query";

import { getSessionsRefetchInterval } from "@/features/coaching/utils";
import { coachingQueriesStore } from "../api";

interface UseOngoingSessionsParams {
  enabled?: boolean;
}

export const useOngoingSessions = ({
  enabled,
}: UseOngoingSessionsParams = {}) => {
  return useQuery({
    ...coachingQueriesStore.coaching.patient._ctx.session._ctx.ongoing,
    refetchInterval: ({ state: { data } }) => getSessionsRefetchInterval(data),
    enabled,
  });
};
